import * as React from 'react';
import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import { FaRegEye, FaTrash } from "react-icons/fa";
import BeHead from '../../Components/Head/BeHead';
import { httpService } from '../../Services/http.service';
import { API_ENDPOINTS } from '../../config/api.config';
import { toast } from 'react-toastify';
// import logo from "../../../Assets/Images/Bloc-Logo.png";
// import image1 from '../../../Assets/Images/image1.png';

export default function SelectBeProjetc() {
  const [demandes, setDemandes] = useState([]);
  const [projects, setProjects] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    currentPage: 1
  });

  const handleDeleteDemande = async (demandeId, demandeRef) => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer la demande ${demandeRef} ? Cette action est irréversible.`)) {
      try {
        await httpService.delete(API_ENDPOINTS.DEMANDES.DELETE(demandeId));
        toast.success("Demande supprimée avec succès !");
        // Mettre à jour la liste des demandes après la suppression
        setDemandes(demandes.filter(d => d.id !== demandeId));
      } catch (error) {
        console.error("Erreur lors de la suppression de la demande :", error);
        toast.error("Échec de la suppression de la demande.");
      }
    }
  };

  // Récupérer les noms des projets
  const fetchProjectNames = async (demandes) => {
    const projectIds = [...new Set(demandes.map(d => d.projet).filter(id => id))];
    const projectsMap = {};
    
    console.log('IDs des projets à récupérer:', projectIds);
    
    for (const projectId of projectIds) {
      try {
        const project = await httpService.get(API_ENDPOINTS.PROJECTS.DETAIL(projectId));
        console.log(`Projet ${projectId} récupéré:`, project);
        
        // Essayer différents champs possibles pour le nom du projet
        const projectName = project.name || project.title || project.nom || project.project_name || `Projet #${projectId}`;
        projectsMap[projectId] = projectName;
        
        console.log(`Nom du projet ${projectId}:`, projectName);
      } catch (error) {
        console.warn(`Erreur lors de la récupération du projet ${projectId}:`, error);
        projectsMap[projectId] = `Projet #${projectId}`;
      }
    }
    
    console.log('Map des projets:', projectsMap);
    return projectsMap;
  };

  
  // Récupérer les demandes depuis l'API
  useEffect(() => {
    const fetchDemandes = async (page = 1) => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Récupération des demandes depuis l\'API...');
        
        const response = await httpService.get(API_ENDPOINTS.DEMANDES.LIST(page));
        console.log('Demandes récupérées:', response);
        
        const allDemandes = response.results || [];
        
        setDemandes(allDemandes);
        
        // Récupérer les noms des projets
        const projectsMap = await fetchProjectNames(allDemandes);
        setProjects(projectsMap);
        
        setPagination({
          count: allDemandes.length,
          next: response.next,
          previous: response.previous,
          currentPage: page
        });
        
      } catch (apiError) {
        console.error('Erreur API:', apiError);
        
        // Si l'API n'est pas disponible, afficher un message informatif
        if (apiError.status === 404) {
          setError('L\'endpoint des demandes n\'est pas encore disponible sur le serveur.');
        } else {
          setError('Erreur lors du chargement des demandes: ' + (apiError.message || 'Erreur inconnue'));
        }
        
        // Afficher une liste vide
        setDemandes([]);
        setProjects({});
        setPagination({
          count: 0,
          next: null,
          previous: null,
          currentPage: 1
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDemandes();
  }, []);
  
  const handleRowClick = (row) => {
    console.log('Ligne cliquée :', row);
    // Exemple : redirection, modal, etc.
    // navigate(`/details/${row.name}`); ou openModal(row)
  };

const getStateColor = (state) => {
  switch (state.toLowerCase()) {
    case 'en attente':
      return '#F59E0B'; // orange
    case 'en cours':
      return '#1E40AF'; // bleu
    case 'etudié':
      return '#10B981'; // vert
    case 'rejeté':
      return '#EF4444'; // rouge
    default:
      return '#6B7280'; // gris
  }
};

const getStateColorForSpan = (state) => {
  switch (state.toLowerCase()) {
    case 'en attente':
      return 'rgba(245, 158, 11, 0.2)'; // orange
    case 'etudié':
      return 'rgba(16, 185, 129, 0.2)'; // vert
    case 'en cours':
      return 'rgba(30, 64, 175, 0.2)'; // bleu
    case 'rejeté':
      return 'rgba(239, 68, 68, 0.2)'; // rouge
    default:
      return 'rgba(107, 114, 128, 0.2)'; // gris
  }
};

  // Fonction pour formater la date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (error) {
      return 'Date invalide';
    }
  };

  // Fonction pour obtenir le statut de la demande
  const getDemandeStatus = (demande) => {
    // Essayer différents champs possibles pour le statut
    return demande.project_step || demande.status || demande.etat || 'En attente';
  };

  // Fonction pour obtenir le nom du demandeur
  const getDemandeName = (demande) => {
    return demande.name || demande.submitted_by_username || 'N/A';
  };

  // Fonction pour obtenir le projet associé
  const getDemandeProject = (demande) => {
    if (demande.projet && projects[demande.projet]) {
      return projects[demande.projet];
    }
    return demande.projet ? `Projet #${demande.projet}` : 'Aucun projet';
  };

  if (loading) {
    return (
      <>
        <BeHead />
        <div className="content-body">
          <div className="container-fluid">
            <div className="bg-white p-5 ml-4">
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Chargement...</span>
                </div>
                <p className="mt-2">Chargement des projets...</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <BeHead />
        <div className="content-body">
          <div className="container-fluid">
            <div className="bg-white p-5 ml-4">
              <div className="alert alert-warning">
                <h4 className="alert-heading">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  Service non disponible
                </h4>
                <p>{error}</p>
                <hr />
                <div className="mb-3">
                  <h6>Solutions possibles :</h6>
                  <ul className="mb-0">
                    <li>Vérifiez que le serveur backend est démarré</li>
                    <li>Contactez l'administrateur pour activer l'endpoint des demandes</li>
                    <li>Vérifiez votre connexion internet</li>
                  </ul>
                </div>
                <button 
                  className="btn btn-outline-warning" 
                  onClick={() => window.location.reload()}
                >
                  <i className="fas fa-refresh me-2"></i>
                  Réessayer
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
        <BeHead />
      <div className="content-body">
        <div className="container-fluid">
          <div className="">
            <div className="bg-white p-5 ml-4">
              <div className="mb-5">
                <p className="fw-bold fs-3">
                  {/* <LiaTimesSolid /> */}
                  </p>
                <div className="title pt-2">
                  <h1 className="">Demandes du Bureau d'Étude</h1>
                  <p className="text-muted">Total: {pagination.count} demande{pagination.count > 1 ? 's' : ''}</p>
                  {/* <p className="fst-italic">NB: Vous pourrez modifier le titre du projet plustard si vous le souhaitez</p> */}
                </div>


              </div>
              <TableContainer component={Paper} sx={{}}>
                <Table sx={{ minWidth: 650, fontSize: 18 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Demandeur</TableCell>
                      <TableCell align="left">Projet</TableCell>
                      <TableCell align="left">État</TableCell>
                      <TableCell align="left">Date de soumission</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {demandes.length > 0 ? (
                      demandes.map((demande, index) => {
                        const status = getDemandeStatus(demande);
                        const demandeur = getDemandeName(demande);
                        const projet = getDemandeProject(demande);
                        
                        return (
                          <TableRow
                            key={demande.id || index}
                            sx={{ 
                              '&:last-child td, &:last-child th': { border: 0 },
                              textDecoration: 'none',
                              color: 'inherit',
                              cursor: 'pointer',
                              '&:hover': {
                                backgroundColor: '#f5f5f5',
                              }
                            }}
                          >
                            <TableCell component="th" scope="row">
                              <div>
                                <div className="fw-bold">{demandeur}</div>
                                {demande.email && (
                                  <small className="text-muted">{demande.email}</small>
                                )}
                              </div>
                            </TableCell>
                            <TableCell align="left">
                              <div>
                                <div>{projet}</div>
                                {demande.adresse && (
                                  <small className="text-muted">{demande.adresse}</small>
                                )}
                              </div>
                            </TableCell>
                            <TableCell align="left" sx={{ color: getStateColor(status), fontWeight: 'bold' }}>
                                <span className='py-1 px-2' style={{backgroundColor: getStateColorForSpan(status), borderRadius: '5px'}}>{status}</span>
                            </TableCell>
                            <TableCell align="left">
                              {formatDate(demande.submitted_at)}
                            </TableCell>
                            <TableCell align="left">
                              <Link 
                                to={`/demande-details/${demande.id}`}
                                className="btn btn-outline-primary btn-sm"
                              >
                                <FaRegEye className='me-2' />Voir
                              </Link>
                              <button
                                className="btn btn-outline-danger btn-sm ms-2"
                                onClick={() => handleDeleteDemande(demande.id, demande.reference_chantier)}
                              >
                                <FaTrash className='me-2' />Supprimer
                              </button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          <div className="text-center py-4">
                            <p className="text-muted">Aucune demande trouvée</p>
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}